// src/liveScreens.ts
//
// Líně načítané obrazovky živého bodování mimo obrazovku rozhodčího (úklid
// a rychlost, 12. 10. 2026): nastavení závodu a živé výsledky. Jsou zvlášť
// od App.tsx, aby je mohla stáhnout předem i spodní navigace (AppShell),
// jakmile má uživatel běžící závod k rozhodování – na střelnici bez signálu
// se pak otevřou i offline (hlavní rozhodčí přidává nováčka, rozhodčí se
// dívá na živé výsledky). Obrazovka rozhodčího sama je v hlavním bundlu.

import { lazyRoute } from "./ui/lazyRoute";

export const LiveRaceSetup = lazyRoute(() => import(/* webpackChunkName: "live-setup" */ "./LiveRaceSetup"));
export const AdminLiveResults = lazyRoute(() => import(/* webpackChunkName: "live-results" */ "./AdminLiveResults"));

/** Obrazovky, které se rozhodčím stahují předem (preloadWhenIdle). */
export const LIVE_SCREENS = [AdminLiveResults, LiveRaceSetup];
